import {JsonApiError} from '@/utils/jsonapiClient';

// Surface 4xx server messages (including occupancy 422); hide 5xx/network behind fallback.
export default function submissionErrorMessage(
  error: unknown,
  fallback: string
): string {
  if (
    error instanceof JsonApiError &&
    typeof error.status === 'number' &&
    error.status >= 400 &&
    error.status < 500 &&
    error.message
  ) {
    return error.message;
  }
  return fallback;
}
